import { render, staticRenderFns } from "./HandleOrder.vue?vue&type=template&id=37528611&scoped=true"
import script from "./HandleOrder.vue?vue&type=script&lang=js"
export * from "./HandleOrder.vue?vue&type=script&lang=js"
import style0 from "./HandleOrder.vue?vue&type=style&index=0&id=37528611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37528611",
  null
  
)

export default component.exports